import { styled } from '@linaria/react';
export const NoStyleLink = /*#__PURE__*/styled('a')({
  name: "NoStyleLink",
  class: "n6y7wvt",
  propsAsIs: false
});

require("./index.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");